/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { SharedAppConstants } from '@tock/shared-app-constants';
import { core } from '@tock/coretypes';
import protos from 'utils/protos';

const { ValidatePhoneRequest } = protos;

export interface FunctionTypes {
  setLoggedInPatron(patron: string): BaseTockAction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setLoggedInPatron(patron: any): BaseTockAction {
  return {
    type: 'SET_LOGGED_IN_PATRON',
    payload: patron,
  };
}
/**
 * Clear cards in the store.
 * @returns {Object} A redux TockApi action.
 */
export function clearCards(): BaseTockAction {
  return {
    type: SharedAppConstants.PATRON_CARDS_CLEAR,
  };
}

/**
 * Fetches all the cards for a given patron
 * @param {Number} patronId The patron for whom we should get the cards
 * @param {Number} purchaseId The original purchase that could contain cards
 *                            used to edit the current purchase.
 * @returns {Object} A redux TockApi action.
 */
export function fetchCardsForPatron(patronId: number, purchaseId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/admin/payment/card?patronId=${patronId}&purchaseId=${purchaseId}`,
      type: SharedAppConstants.PATRON_CARDS_FETCH_ALL,
    },
  };
}

/**
 * Get a patron's book via emails
 *
 * @param {number} patronId The id of the patron to fetch.
 * @returns {Object} A redux TockApi action.
 */
export function getBookViaEmailsHistory(patronId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/purchase/verify/patron/${patronId}`,
      type: SharedAppConstants.PATRON_FETCH_PAY_BY_EMAILS,
    },
  };
}

/**
 * Get a patron's history
 *
 * @param {number} patronId The id of the patron to fetch.
 * @returns {Object} A redux TockApi action.
 */
export function getPurchaseHistory(patronId: number): ApiAction {
  return {
    TockApi: {
      batchProto: [
        {
          path: `/admin/purchase?patronId=${patronId}`,
          method: 'GET',
        },
        {
          path: `/admin/transfer/legacy?patronId=${patronId}`,
          method: 'GET',
        },
      ],
      type: SharedAppConstants.PATRON_FETCH_PURCHASE_HISTORY,
    },
  };
}

export function updatePurchaseHistoryPurchase(purchase: core.IPastPurchase): BaseTockAction {
  return {
    type: SharedAppConstants.PATRON_UPDATE_PURCHASE_HISTORY_PURCHASE,
    payload: purchase,
  };
}

/**
 * Get a patron's waitlist information for a business
 * @param {Number} patronId The patron for whom we should retrieve waitlist information
 * @returns {Object} A redux TockApi action.
 */
export function getWaitlistHistory(patronId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/waitlist/patron/${patronId}`,
      type: SharedAppConstants.PATRON_FETCH_WAITLIST,
    },
  };
}

export function deleteWaitlist(waitlistId: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/waitlist/${waitlistId}`,
      type: SharedAppConstants.WAITLIST_DELETE,
    },
  };
}

export function getWalkInHistory(patronId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/visit/patron?patronId=${patronId}&walkInsOnly=${true}`,
      type: SharedAppConstants.PATRON_FETCH_WALKINS,
    },
  };
}

export function validatePhoneRequest(request: core.ValidatePhoneRequest): ApiAction {
  return {
    TockApi: {
      request: ValidatePhoneRequest.fromObject(request),
      postProto: '/consumer/phone/validate',
      type: SharedAppConstants.VALIDATE_PHONE_REQUEST,
    },
  };
}

export function getPosCheckHistory(patronId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/pos/check/patron?patronId=${patronId}`,
      type: SharedAppConstants.PATRON_FETCH_CHECKS,
    },
  };
}

export function detectLocation(): ApiAction {
  return {
    TockApi: {
      getProto: `/location/detect`,
      type: SharedAppConstants.DETECT_LOCATION,
    },
  };
}
